export type PurDraftKind = "materialRequests" | "purchaseOrders";
export interface PurDraftCreateInput {
  kind: PurDraftKind;
  projectId: number;
  storageId: number;
  // Set from the currently selected division just before an MR is saved.
  requestingDivisionId?: number;
  vendorId?: number;
  date: string;
  deliveryDate: string;
  text: string;
  vatRate?: string;
  lines: Array<{ productId: number; unitId: number; quantity: string; factor: string; unitCost?: string; discount?: string }>;
}
// Historical TEST-A fixture: recheck its identity/scope before each real create.
// Kept dependency-free so local form validation never loads API configuration.
export const PUR_CREATE_PILOT = {
  host: "https://sapiens-beta-api.ishealth.app", divisionId: 106,
  projectId: 1, storageId: 3, vendorId: 1,
  projectMarker: "MEERP-TEST-106-20260927-1228-3241",
};
